import { http } from '../../config/axios'

export default function putPermission(permission: any): Promise<string> {
  return http
    .put('api/permissao', permission)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put permission', error)
      throw Error(error.response.data)
    })
}
